<template>
  <div id="app">
    <Loader v-if="isLoading" />
    <!-- <div v-if="isLoading">
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      <div>Loading... ({{refCount}})</div>
    </div> -->
    <router-view></router-view>
    <notifications group="notifications" width="400" />
  </div>
</template>

<script>
import util from "@/util/util";
import { mapState } from "vuex";
import Loader from "@/components/Loader";
export default {
  name: "App",
  components: {
    Loader,
  },
  computed: {
    ...mapState({
      isLoading: state => state.isLoading,
    }),
  },
  // created() {
  //   this.axios.interceptors.request.use(
  //     (config) => {
  //       this.$store.commit("loading", true);
  //       return config;
  //     },
  //     (error) => {
  //       this.$store.commit("loading", false);
  //       return Promise.reject(error);
  //     }
  //   );

  //   this.axios.interceptors.response.use(
  //     (response) => {
  //       this.$store.commit("loading", false);
  //       return response;
  //     },
  //     (error) => {
  //       this.$store.commit("loading", false);
  //       return Promise.reject(error);
  //     }
  //   );
  // },
  mounted() {
    util.bindEvent.call(this, {
      channelName: "routeCalled",
      eventName: "RouteCalled",
      callback: (e) => {
        console.log(e);
      },
    });
  },
};
</script>

<style></style>
